const mixins = {
  methods: {
    /**
     * Get the component props directly from the component
     * @method getComponentProps
     * @return void
     * 1. Open the .vue file of the component that needs documentation
     * 2. import docs from '../../../../helpers/methods'
     * 3. mixins: [docs]
     * 4. mounted () { this.getComponentProps() }
     * 5. Open the console
     * 6. Reload the page
     * 7. Copy the output
     * 8. Add to the server response
     * */
    getComponentProps () {
      const props = this.constructor.options.props
      const map = []
      Object.keys(props).forEach(prop => {
        const item = [
          prop, // prop name [String]
          props[prop].type.name, // prop type [String, Object, Boolean, etc]
          props[prop].required, // prop required [Boolean]
          props[prop].default, // prop default value [Any]
          'add prop description...' // prop description [String]
        ]
        map.push(item)
      })
      console.info('"props": ' + JSON.stringify(map, null, 2))
    },
    /**
     * Render a page from the $store
     * @method setPage
     * */
    setPage () {
      const path = this.$route.path
      const store = this.$store
      const state = store.state
      const events = state.events
      let pageData = store.getters.page(path)
      this.title = pageData ? pageData.title : `<span class="font-red">${this.getLangKey('noServerSideRenderingYet')} ("<strong>${path}</strong>")</span>`
      this.description = pageData ? pageData.longDescription : `<p class="font-red">${this.getLangKey('replacementParagraph')}</p>`
      this.$root.hasApi = false
      if (!pageData) {
        pageData = {}
      }
      if (pageData.api) {
        this.$refs['api-grid'].api = pageData.api
        let prop = 0
        for (let key in pageData.api.components) {
          if (pageData.api.components[key].props.length > prop) {
            prop = pageData.api.components[key].props.length
          }
        }
        this.$root.$emit(events.hasApi, true)
        this.$refs['api-grid'].tabHeight = (prop + 1) * 2 * 32
      } else {
        this.$root.$emit(events.hasApi, false)
      }
      this.$root.$emit(events.pageReady, pageData)
      this.$root.$emit(events.ajaxEnd)
      this.$nextTick(() => {
        const pageLinks = document.querySelectorAll('.server-side-description [v-link]')
        const router = this.$router
        Array.prototype.forEach.call(pageLinks, function (a) {
          a.onclick = function (e) {
            const href = a.getAttribute('href')
            e.preventDefault()
            router.push({
              path: href
            })
          }
        })
      })
    },
    /**
     * Get language key from $store.lang
     * @method getLangKey
     * @param {String} key
     * @return {String}
     * */
    getLangKey (key) {
      return this.$store.state.lang[key]
    },
    /**
     * Get page from the API
     * @method getPage
     * */
    getPage () {
      const path = this.$route.path
      const store = this.$store
      const events = store.state.events
      const apiEndpoint = store.getters.apiEndpoint
      if (store.getters.page(path)) {
        return this.setPage()
      }
      this.$root.$emit(events.ajaxStart)
      this.$http({
        url: `${apiEndpoint}${path}?json`,
        _timeout: 500
      })
        .then(response => {
          response = response.data
          if (!store.getters.siteDetails) {
            store.commit('storeSiteDetails', {
              title: response.siteTitle,
              subtitle: response.siteSubtitle,
              description: response.siteDescription
            })
            this.$root.$emit(events.ready, store.getters.siteDetails)
          }
          if (response.status !== 'fail') {
            store.commit('storePage', response.route)
          }
          this.setPage()
        })
        .catch((error) => {
          console.log('[api error]', error)
          this.$root.$emit(events.ajaxEnd)
        })
    },
    setCategoryColor () {
      const category = this.$route.path.split('/').splice(1, 1).join()
      let color = this.navigation.filter(item => item.items === category)
      color = color[0] ? color[0].color : 'primary'
      this.$store.commit('setCategoryColor', color)
    },
    viewport () {
      const w = window
      const d = document
      const e = d.documentElement
      const g = d.getElementsByTagName('body')[0]
      const width = w.innerWidth || e.clientWidth || g.clientWidth
      const height = w.innerHeight || e.clientHeight || g.clientHeight
      return {
        width,
        height
      }
    },
    sendGaEvent (eventCategory, eventAction, eventLabel) {
      window.ga('send', 'event', {
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel
      })
    }
  }
}

export default mixins



// WEBPACK FOOTER //
// ./src/helpers/methods.js